
import {getGuid} from '@utils'
import Upload from '@/components/UploadImage'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
XTextarea,
Cell,
Tab,
TabItem,
Upload,
Group,
XButton
},
data() {
return {
ID: '',
desp: '',
files: [],
uploadParams: {
SUBDIR: this.$config.SUBDIR.abn
},
}
},
computed: {
position() {
return this.$store.getters.getPosition
}
},
created() {
let _this = this
this.ID = this.$route.query.ID || ''
this.TYPE = this.$route.query.TYPE || ''
this.$store.dispatch('baiduPosition')
},
methods: {
submitAbn() {
let _this = this;
if (!this.position.addr) {
this.$toast.text('未获取到位置，请确认定位是否打开')
return
}
if (!this.desp) {
this.$toast.text('请先录入异常描述')
return
}
if (this.files.length == 0) {
this.$toast.text('请上传异常照片')
return
}

let fileArr = [];
this.files.forEach(item=>{
fileArr.push(item.src)
})
let param = {
GUID: getGuid(),
TRANS_ID: _this.ID,
ABN_TYPE: _this.TYPE,
ABN_DESP: _this.desp,
SLAT: _this.position.lat,
SLNG: _this.position.lng,
ADDR: _this.position.addr,
ABN_SRC: fileArr.join(',')
};
_this.$post('Trans_ABN.ashx?action=Form_Save', param).then(res => {
_this.$toast.success('操作成功')
_this.$router.back()
})
}
},
}



// WEBPACK FOOTER //
// ./src/pages/Asus/Abnormal.vue